import { generateTotalSalesData } from './data';

export const mockGetTotalSalesData = async (variables: {
  chatUUID: string;
  endTime: string;
  startTime: string;
}) => {
  const filteredSalesData = await generateTotalSalesData(
    variables.chatUUID,
    new Date(variables.endTime),
    new Date(variables.startTime),
  );

  return Promise.resolve({
    data: {
      salesData: filteredSalesData,
    },
  });
};
